import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "model/interface/api/IRestServiceOptions";
import {IStreamEventsState} from "../../../redux/reducers/StreamEvents";


const COLLECTION = 'setup-stream-events'

interface ICollectionService {
    setup: (options?: IRestServiceOptions) => Promise<IStreamServiceResponse>
}

export interface IStreamServiceResponse extends IStreamEventsState{
    sse_token: string
}

const StreamEventsService: ICollectionService = {
    setup: function (options?: IRestServiceOptions) {
        return RestService.customRetrieve<IStreamServiceResponse>(COLLECTION, options)
    }
}

export default StreamEventsService